<div class="dialog-heading">
  <h5>{{ data.title }}</h5>
  <span class="flex-fill"></span>
  <mat-icon class="close-dialog" aria-hidden="false" [mat-dialog-close]="{ confirmed: false }" aria-label="Close icon"> close</mat-icon>
</div>

<mat-dialog-content [formGroup]="frmTextArea">
  <div class="padTop">
    <label class="controlText">{{data.textAreaTitle}}</label>
    <mat-form-field class="full-width" appearance="outline">
      <textarea rows="6" class="full-width" matInput formControlName="textAreaControl"></textarea>
    </mat-form-field>
      <mat-error *ngIf="this.frmTextArea.get('textAreaControl').errors?.maxlength"> Cannot be more than 255 characters. </mat-error>
      <mat-error *ngIf="this.frmTextArea.get('textAreaControl').touched && this.frmTextArea.get('textAreaControl').errors?.required"> Please enter a rejection reason </mat-error>
  </div>
</mat-dialog-content>

<!-- This are the actions of the dialog, containing the primary and the cancel button-->
<mat-dialog-actions class="actions">
  <button mat-flat-button color="accent" (click)="send()">Send</button>
  <button mat-stroked-button color="accent" [mat-dialog-close]="{ confirmed: false }">Cancel</button>
</mat-dialog-actions>
